module.exports = __webpack_public_path__ + "static/media/logo.feab9747.svg";